module.exports = {
  // Waiting BE to resolve the endpoint!
  // getMarketplace: async ({ commit, dispatch }) => {
  //   const config = {
  //     method: 'get',
  //     url: 'members/rewards'
  //   }
  //   const response = await dispatch('sendRequest', config, { root: true })

  //   if (response.status === 'ok') {
  //     commit('setMarketplace', response.data)
  //     commit('setRewards', response.data)
  //     return null
  //   } else {
  //     return response.message
  //   }
  // }, 
  getRedeemables: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'members/rewards/redeemables'
    }
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setRedeemables', response.data)
      return null
    } else {
      return response.message
    }
  },
  getRewards: async ({ commit, dispatch, rootState }) => {
    const config = {
      method: 'get',
      url: 'members/rewards'
    }

    if (rootState.userChannel !== 'US') {
      config.headers = {
        client_sub: rootState.userChannel.toLowerCase()
      }
    }
    
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setRewards', response.data)
      return null
    } else {
      return response.message
    }
  },
  redeemReward: async ({ dispatch, rootState }, params) => {
    const config = {
      method: 'put',
      url: 'members/rewards',
      data: params
    }

    if (rootState.userChannel !== 'US') {
      config.headers = {
        client_sub: rootState.userChannel.toLowerCase()
      }
    }
    
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      await dispatch('members/getRewards')
      return response
    } else {
      return response
    }
  },
  getOffers: async ({ commit, dispatch, rootState }) => {
    if (rootState.appInfo && rootState.appInfo.disabled_features && rootState.appInfo.disabled_features.get_offers) {
      return false
    }

    const config = {
      method: 'post',
      url: 'members/rewards'
    }

    if (rootState.userChannel !== 'US') {
      config.headers = {
        client_sub: rootState.userChannel.toLowerCase()
      }
    }

    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setOffers', response.data)
      return null
    } else {
      return response.message
    }
  },
  getPayments: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'members/payments'
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      commit('setPayments', response.data)
      return null
    } else {
      return response.message
    }
  },
  deletePayments: async ({ commit, dispatch }, id) => {
    const config = {
      method: 'delete',
      url: `members/payments/${id}`
    }
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setPayments', response.data)
      return null
    } else {
      return response.message
    }
  },
  getFavLocs: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'members/faves/locations'
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      commit('setFavLocs', response.data)
      return null
    } else {
      return response.message
    }
  },
  saveFavLoc: async ({ commit, dispatch }, menuId) => {
    const config = {
      method: 'post',
      url: 'members/faves/locations',
      data: {
        menu_id: menuId
      },
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      commit('setFavLocs', response.data)
      return true
    } else {
      let messages = []
      if (typeof response.message === 'string') {
        messages.push(response.message)
      } else if (Array.isArray(response.message)) {
        messages = [...response.message]
      } else {
        messages = response.message
      }
      commit('setErrors', messages, { root: true })
    }
    return false
  },
  deleteFavLoc: async ({ commit, dispatch }, menuId) => {
    const config = {
      method: 'delete',
      url: `members/faves/locations/${menuId}`,
      data: {
        menu_id: menuId
      },
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      commit('setFavLocs', response.data)
      return null
    } else {
      let messages = []
      if (typeof response.message === 'string') {
        messages.push(response.message)
      } else if (Array.isArray(response.message)) {
        messages = [...response.message]
      } else {
        messages = response.message
      }
      commit('setErrors', messages, { root: true })
    }
  },
  getSignUpOptions: async ({ commit, dispatch }, zip) => {
    const config = {
      method: 'post',
      url: 'members/options',
      date: {
        zip: zip
      }
    }
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      commit('setSignUpOptions', response.data)
      return null
    } else {
      return response.message
    }
  },
  getAddresses: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'members/addresses'
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      commit('setAddresses', response.data)
      return null
    } else {
      return response.message
    }
  },
  deleteAddresses: async ({ dispatch }, addressId) => {
    const config = {
      method: 'delete',
      url: `members/addresses/${addressId}`
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      return true
    } else {
      return response.message
    }
  },
  updateMember: async ({ commit, dispatch }, data) => {
    const config = {
      method: 'put',
      url: `members`,
      data
    }
    const response = await dispatch('sendRequest', config, { root: true })

    if (response.status === 'ok') {
      if (response.data.email) {
        commit('setUser', response.data, { root: true })
      } else {
        commit('setUser', data, { root: true })
      }
      return response
    } else {
      return response
    }
  },

  deleteMember: async ({ dispatch }) => {
    const config = {
      method: 'delete',
      url: `members`
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      return true
    } else {
      return response.message
    }
  },
  
  getChallenges: async ({ dispatch, commit }) => {
    const config = {
      method: 'get',
      url: 'challenges'
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      await commit('setChallenges', response.data)
      
      // hydrate challenges
      if (response.data.length > 0 && response.data.length < 10) {
        const hydratedChallenges = []
        for (const challenge of response.data) {
          const hydrated = await dispatch('getChallengeDetails', challenge.id)
          hydratedChallenges.push({
            ...challenge,
            ...hydrated,
          })
        }
      
        await commit('setChallenges', hydratedChallenges)
      }
      return true
    } else {
      return response.message
    }
  },
  getChallengeDetails: async ({ dispatch }, challengeID) => {
    const config = {
      method: 'get',
      url: `challenges/${challengeID}`
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      return response.data
    } else {
      // TODO: what should I return if this fails?
      return {}
    }
  },
  getBadges: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'challenges/badges'
    }
    const response = await dispatch('sendRequest', config, { root: true })
    
    if (response.status === 'ok') {
      commit('setBadges', response.data)
      return null
    } else {
      return response.message
    }
  },
}
